import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { ITag } from './ITag';

export interface IGetTagsParams extends IGetItemsParams {
}

export interface IGetTagsResult extends IGetItemsResult {
  tags: ITag[];
}

export class GetTagsRequest extends Request<IGetTagsParams, IGetTagsResult> {
  constructor(params: IGetTagsParams) {
    super('getTags', params);
  }
}
